export default {
  withdraw: {
    title: 'Tarik',
    subtitle: 'Cepat, aman, dan nyaman',
    secureEncrypted: 'Aman dan Terenkripsi',
    fiatOrCash: 'Fiat/Tunai',
    processing: 'Memproses...',
    select: 'Pilih',
    withdrawCurrency: 'Mata Uang Penarikan',
    chooseNetwork: 'Pilih Jaringan',
    channel: 'Saluran',
    withdrawalAddress: 'Alamat Penarikan',
    pixKeyType: 'Tipe Kunci PIX',
    accountNumber: 'Nomor Rekening',
    enterAccountNumber: 'Masukkan nomor rekening Anda',
    accountName: 'Nama Rekening',
    enterAccountName: 'Masukkan nama pemilik rekening',
    pixKey: 'Kunci PIX',
    enterPixKey: 'Masukkan kunci PIX Anda',
    cpf: 'CPF',
    enterCpf: 'Masukkan CPF',
    bankName: 'Nama Bank',
    enterBankName: 'Masukkan nama bank',
    branch: 'Cabang',
    enterBranch: 'Masukkan cabang (opsional)',
    phone: 'Telepon',
    enterPhone: 'Masukkan telepon (opsional)',
    email: 'Email',
    enterEmail: 'Masukkan email (opsional)',
    available: 'Dapat ditarik',
    amountPlaceholder: 'Jumlah ({unit})',
    min: 'Min',
    max: 'Maks',
    totalWithdrawalAmount: 'Total jumlah penarikan:',
    fee: 'Biaya:',
    withdrawalAmount: 'Jumlah Penarikan:',
    fundsSafeTitle: 'Dana Anda aman bersama kami',
    fundsSafeDesc: 'Kami menggunakan keamanan terdepan untuk melindungi transaksi dan informasi pribadi Anda.',
    enterWithdrawalAddress: 'Silakan masukkan alamat penarikan',
    enterAccountNumberRequired: 'Silakan masukkan nomor rekening Anda',
    selectChannelRequired: 'Silakan pilih saluran',
    enterAccountNameRequired: 'Silakan masukkan nama pemilik rekening',
    selectPixKeyTypeRequired: 'Silakan pilih tipe kunci PIX',
    enterCpfRequired: 'Silakan masukkan CPF',
    enterValidAmount: 'Silakan masukkan jumlah yang valid',
    minWithdrawal: 'Penarikan minimum: {amount} {unit}',
    maxWithdrawal: 'Penarikan maksimum: {amount} {unit}',
    insufficientBalance: 'Saldo tersedia tidak cukup',
    withdrawalRejected: 'Penarikan ditolak',
    submittedPendingReview: 'Penarikan dikirim, menunggu peninjauan',
    submittedPayoutInProgress: 'Penarikan dikirim, pembayaran sedang diproses',
    withdrawalFailed: 'Penarikan gagal',
    withdrawalFailedRetry: 'Penarikan gagal, silakan coba lagi',
  },
};
